import { MultiSelect } from '@/components/ui/multi-select';
import { StatusServerlessProjectLabel } from '@/service/serverless-gpu/type';
import { Input } from '@/components/ui/input';
import { DatePickerWithRange } from '@/components/ui/date-picker/date-range-picker';
import { SearchIcon } from 'lucide-react';
import { DateRange } from 'react-day-picker';

type FormSchemaFilter = {
  searchString: string;
  status: string[];
  date: DateRange | undefined;
};

type Props = {
  filter: FormSchemaFilter;
  onFilterChange: (filter: FormSchemaFilter) => void;
};

const ProjectSearch = ({ filter, onFilterChange }: Props) => {
  const optionsStatus = Object.entries(StatusServerlessProjectLabel).map(
    ([value, label]) => ({
      value,
      label,
    })
  );

  return (
    <div className="flex flex-col gap-2 lg:flex-row">
      <div className="flex-1">
        <Input
          value={filter.searchString}
          onChange={(e) => onFilterChange({ ...filter, searchString: e.target.value })}
          placeholder="Search by Project ID or Name"
          startIcon={<SearchIcon className="h-4 w-4 text-gray-400" />}
        />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <MultiSelect
          options={optionsStatus}
          value={filter.status}
          onValueChange={(status) => onFilterChange({ ...filter, status })}
          placeholder="Select Status"
          className="w-[220px]"
          compact

        />
        <DatePickerWithRange
          className="w-[250px]"
          value={filter.date}
          onChange={(date) => onFilterChange({ ...filter, date: date as DateRange })}
          placeholder="Filter Date"
        />
      </div>
    </div>
  );
};

export default ProjectSearch; 